import { makeStyles } from '@mui/styles';
import { MIDNIGHT_EXPRESS } from '@returnmates/client-core/src/constants/colors';
import { POPPINS } from '../../constants/styles/fonts';
var useStyles = makeStyles(function () { return ({
    addresses: {},
    defaultAddress: {
        marginLeft: 8,
        padding: '2px 6px',
        display: 'inline-block',
        backgroundColor: 'rgba(50, 200, 50, 0.3)',
        borderRadius: 10,
        fontSize: 10,
    },
    reviewPartTop: {},
    reviewPartTopName: {
        display: 'flex',
        alignItems: 'baseline',
        fontFamily: POPPINS,
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '160%',
        color: MIDNIGHT_EXPRESS,
    },
    topName: {
        flexGrow: 1,
    },
    editAddressInfo: {
        display: 'flex',
        alignItems: 'center',
    },
    reviewPartTopAddress: {
        fontFamily: POPPINS,
        fontSize: 14,
        lineHeight: '160%',
        color: MIDNIGHT_EXPRESS,
        marginTop: 5,
    },
    pencil: {
        height: 14,
        marginLeft: 10,
    },
    '@media screen and (max-width: 700px)': {
        addresses: {
            width: '100%',
        },
    },
}); });
export default useStyles;
//# sourceMappingURL=styles.js.map